module.exports = __webpack_public_path__ + "media/images/img-fairy-466feec8ecd6b512031eefd8660d3ee3.svg";